import { ChangeDetectionStrategy, Component, inject, Signal, signal, ViewChild } from '@angular/core';
import { EtiquetteFormComponent } from '../../forms/etiquette-form/etiquette-form';
import { Popover } from 'primeng/popover';
import { CommonModule } from '@angular/common';
import { EtiquetteListComponent } from "../../components/etiquette-list/etiquette-list";
import { AbstractPageComponent, BasePageComponent } from '@spike/scaffolds';
import { EtiquetteStoreService } from '../../services/etiquette-store.service';
import { Button } from "primeng/button";
import { EtiquetteApiEnum } from 'src/app/config/entity-api.enum';
import { EntityEtiquette } from '../../models/entity-etiquette.model';

interface EtiquetteConfig{
  label:string,
  apiEnum: EtiquetteApiEnum,
  list: Signal<EntityEtiquette[]>;
}
@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, BasePageComponent, EtiquetteFormComponent, Popover, EtiquetteListComponent, Button],
  selector: 'spike-etiquette-page',
  templateUrl: './etiquette-page.html'
})
export class EtiquettePageComponent extends AbstractPageComponent{
  @ViewChild('op') op!: Popover;
  //inject  
  private readonly etiquetteStoreService = inject(EtiquetteStoreService);


  //local state
  public selectedEtiquette = signal<EntityEtiquette|undefined|null>(null); 
  public selectedEtiquetteConfig = signal<EtiquetteConfig|null>(null); 

  public etiquetteConfigList: EtiquetteConfig[]=[
    {
      label:'Clienti',
      apiEnum: EtiquetteApiEnum.CLIENT,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.CLIENT)
    },
    {
      label:'Dipendenti',
      apiEnum: EtiquetteApiEnum.EMPLOYEE,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.EMPLOYEE)
    },
    {
      label:'Macchine',
      apiEnum: EtiquetteApiEnum.MACHINE,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.MACHINE)
    },
    {
      label:'Fornitori',
      apiEnum: EtiquetteApiEnum.SUPPLIER,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.SUPPLIER)
    },
    {
      label:'Veicoli',
      apiEnum: EtiquetteApiEnum.VEHICLE,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.VEHICLE)
    }, 
     {
      label:'Tipi materiale',
      apiEnum: EtiquetteApiEnum.EQUIPMENT,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.EQUIPMENT)
    }, 
     {
      label:'Tipi operazione',
      apiEnum: EtiquetteApiEnum.OPERATION,
      list: this.etiquetteStoreService.getList(EtiquetteApiEnum.OPERATION)
    }, 
  ];


  onInsert(event:any, entityType: EtiquetteConfig) {
    this.hidePopup();
    setTimeout(() => {
      this.selectedEtiquetteConfig.set(entityType);
      this.selectedEtiquette.set({
        etiquetteId: null,
        entityTypeId: null,
        shortDescription: null,
        description: null,
        sys: 0
      });
      this.showPopup(event);

    }, 100);
  }  

 

  popoverReady= signal<boolean>(false);

  onClickPropagated(event:any){
    this.hidePopup();
    if(!this.selectedEtiquette()) return;

    setTimeout(() => {
      this.showPopup(event);
    }, 150);
  }

  hidePopup(){
    this.op.hide();
    this.popoverReady.set(false);
  }

  showPopup(event:any){
    this.popoverReady.set(true);
    this.op.show(event);
  }

  onSelect(entityType: EtiquetteConfig, etiquetteId: number|null){
    this.hidePopup();
    this.selectedEtiquetteConfig.set(entityType);
    this.selectedEtiquette.set(entityType.list().find(x=> x.etiquetteId===etiquetteId));
  }
 

  async onDelete(etiquette: EntityEtiquette){
    await this.etiquetteStoreService.deleteById(this.selectedEtiquetteConfig()!.apiEnum, etiquette.etiquetteId!);
    this.hidePopup();
    this.selectedEtiquetteConfig.set(null);
    this.selectedEtiquette.set(null);

  }

   async onSave(etiquette: EntityEtiquette){
    await this.etiquetteStoreService.save(this.selectedEtiquetteConfig()!.apiEnum, etiquette);
    this.hidePopup();
    this.selectedEtiquetteConfig.set(null);
    this.selectedEtiquette.set(null);
  }
}

    